import { IconProps } from '.';

export const NetworkIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      className={className}
      width='15'
      height='16.125'
      viewBox='0 0 15 16.125'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.36'
        d='M9.54488 4.21582L5.4541 6.84551'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        opacity='0.36'
        d='M5.4541 9.27832L9.54488 11.908'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.0625 8.0625C5.0625 7.23407 4.39093 6.5625 3.5625 6.5625C2.73407 6.5625 2.0625 7.23407 2.0625 8.0625C2.0625 8.89093 2.73407 9.5625 3.5625 9.5625C4.39093 9.5625 5.0625 8.89093 5.0625 8.0625ZM6.5625 8.0625C6.5625 9.71935 5.21935 11.0625 3.5625 11.0625C1.90565 11.0625 0.5625 9.71935 0.5625 8.0625C0.5625 6.40565 1.90565 5.0625 3.5625 5.0625C5.21935 5.0625 6.5625 6.40565 6.5625 8.0625Z'
        fill={color}
      />
      <path
        d='M12.9375 13.125C12.9375 12.2966 12.2659 11.625 11.4375 11.625C10.6091 11.625 9.9375 12.2966 9.9375 13.125C9.9375 13.9534 10.6091 14.625 11.4375 14.625C12.2659 14.625 12.9375 13.9534 12.9375 13.125ZM14.4375 13.125C14.4375 14.7819 13.0944 16.125 11.4375 16.125C9.78065 16.125 8.4375 14.7819 8.4375 13.125C8.4375 11.4681 9.78065 10.125 11.4375 10.125C13.0944 10.125 14.4375 11.4681 14.4375 13.125Z'
        fill={color}
      />
      <path
        d='M12.9375 3C12.9375 2.17157 12.2659 1.5 11.4375 1.5C10.6091 1.5 9.9375 2.17157 9.9375 3C9.9375 3.82843 10.6091 4.5 11.4375 4.5C12.2659 4.5 12.9375 3.82843 12.9375 3ZM14.4375 3C14.4375 4.65685 13.0944 6 11.4375 6C9.78065 6 8.4375 4.65685 8.4375 3C8.4375 1.34315 9.78065 0 11.4375 0C13.0944 0 14.4375 1.34315 14.4375 3Z'
        fill={color}
      />
    </svg>
  );
};
